import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import {
  saveServiceKey,
  closeServiceKeyForm,
} from '../store/modules/servicekey';

import FormServiceKey from '../components/FormServiceKey/FormServiceKey';

import 'react-virtualized/styles.css';
import 'react-virtualized-select/styles.css';

const mapActionCreators = {
  saveServiceKey,
  closeServiceKeyForm,
};

const mapStateToProps = (state): {} => ({
  serviceKey: state.serviceKey.serviceKeys[state.serviceKey.formTarget],
  types: _.pick(
    state.serviceType.serviceTypes,
    state.serviceKey.serviceKeys[state.serviceKey.formTarget]
      ? state.serviceKey.serviceKeys[state.serviceKey.formTarget].types
      : null,
  ),
  open: state.serviceKey.formOpen,
  formTarget: state.serviceKey.formTarget,
  user: state.login.user,
});

class ServiceKeyFormContainer extends Component {
  render() {
    if (this.props.open === false) {
      return null;
    }

    return (
      <FormServiceKey
        serviceKey={this.props.serviceKey}
        types={this.props.types}
        saveServiceKey={this.props.saveServiceKey}
        closeServiceKeyForm={this.props.closeServiceKeyForm}
        push={this.props.push}
      />
    );
  }
}

ServiceKeyFormContainer.propTypes = {
  saveServiceKey: PropTypes.func.isRequired,
  closeServiceKeyForm: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired,
  serviceKey: PropTypes.object,
  activity: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
  types: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
  open: PropTypes.bool,
  formTarget: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
};

export default connect(
  mapStateToProps,
  mapActionCreators,
)(ServiceKeyFormContainer);



// WEBPACK FOOTER //
// ./src/containers/ServiceKeyFormContainer.js